/** Shared utility functions used across extracted screen components */

export function frequencyToDoseCount(frequency: string): number {
  const f = frequency.toLowerCase();
  if (/four\s*times|4\s*x|qid/.test(f)) return 4;
  if (/three\s*times|3\s*x|tid/.test(f)) return 3;
  if (/twice|2\s*x|bid/.test(f)) return 2;
  return 1;
}

export function getLocalDate(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function localDateFromTimestamp(ts: string): string {
  if (ts.length >= 10 && !ts.includes('T')) return ts.slice(0, 10);
  const d = new Date(ts);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
